import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment, @typescript-eslint/prefer-ts-expect-error
// @ts-ignore
import { Disclosure } from '@headlessui/react';
import { useState } from 'react';
import { FaChevronRight } from 'react-icons/fa';
import { Input, ValueRenderers } from '../index';
import { Table } from '../table/Table';
const style = {
    container: css({
        padding: '5px',
    }),
    chevron: (open) => css({
        rotate: open ? '90deg' : '0deg',
        transition: 'all 0.3s ease-in-out',
    }),
    button: css({
        display: 'flex',
        alignItems: 'center',
        gap: 5,
        padding: '5px 2px',
    }),
    table: css `
    width: 100%;
    td:first-of-type {
      width: 30%;
    }
  `,
};
export function InfoPanel(props) {
    const [search, setSearch] = useState('');
    const { title = 'Information', data = [], titleStyle, inputStyle, tableStyle, } = props;
    function viewData(data) {
        return Object.keys(data)
            .map((key) => {
            const value = data[key];
            if (!key.toLowerCase().includes(search.toLowerCase()) &&
                !valueSearch(value, search)) {
                return null;
            }
            return (_jsxs(Table.Row, { children: [_jsx(ValueRenderers.Text, { value: key }), valueCell(value)] }, key));
        })
            .filter((row) => row !== null);
    }
    return (_jsxs("div", { css: style.container, children: [_jsx("div", { style: titleStyle, children: title }), _jsx(Input, { placeholder: "search for a parameter ...", value: search, onChange: ({ target }) => {
                    if (target.value !== undefined)
                        setSearch(target.value);
                }, style: inputStyle }), data.map(({ description, data }) => {
                const content = viewData(data);
                return content.length > 0 ? (_jsx(Disclosure, { defaultOpen: true, children: ({ open }) => (_jsxs(_Fragment, { children: [_jsxs(Disclosure.Button, { css: style.button, children: [_jsx(FaChevronRight, { css: style.chevron(open) }), description] }), _jsx(Disclosure.Panel, { children: _jsxs(Table, { css: style.table, style: tableStyle, children: [_jsxs(Table.Header, { children: [_jsx(ValueRenderers.Title, { value: "Parameter" }), _jsx(ValueRenderers.Title, { value: "Value" })] }), content] }) })] })) }, description)) : null;
            })] }));
}
/**
 * Get the value cell depending on the type of the value
 * @param value - ValueRenderers value.
 * @returns - ValueRenderers component.
 */
function valueCell(value) {
    switch (typeof value) {
        case 'number':
            return _jsx(ValueRenderers.Number, { value: value });
        case 'object':
            return _jsx(ValueRenderers.Object, { value: value });
        case 'string':
            return _jsx(ValueRenderers.Text, { value: value });
        default:
            _jsx(ValueRenderers.Text, { value: value });
    }
}
/**
 * Search a string in different type of values
 *
 * @param value - Value to search in.
 * @param search - Value to search for.
 * @returns - If search exist in value
 */
function valueSearch(value, search) {
    switch (typeof value) {
        case 'number':
            return String(value).includes(search.toLowerCase());
        case 'object':
            return JSON.stringify(value).toLowerCase().includes(search.toLowerCase());
        case 'string':
            return value.toLowerCase().includes(search.toLowerCase());
        default:
            return false;
    }
}
//# sourceMappingURL=InfoPanel.js.map